module.exports = __webpack_public_path__ + "img/banner-1.327d6c81.png";